import React, {useContext, useEffect, useState} from 'react';
import AuthContext from "../../Services/AuthContext";
import StyledModal from "../../Component/StyledModal";
import {Alert, Stack, TextField} from "@mui/material";


function EditChildren(props) {
    const title = 'Edytuj Dziecko';
    const description = (<Alert severity="warning"><strong>Zwróć uwagę na poprawność zgłaszanych danych.</strong><br />Organizatorzy mogą na ich podstawie podejmować decyzję o zapisie na wydarzenie.</Alert>);

    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [personalId, setPersonalId] = useState('');
    const [phone, setPhone] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [city, setCity] = useState('');
    const [street, setStreet] = useState('');

    function _send() {
        const formData = {
            name: name,
            surname: surname,
            personal_id: personalId,
            phone: phone,
            postal_code: postalCode,
            city: city,
            street: street
        };
        fetch(`/api/children/${props.data.id}`, {
            method: 'PUT',
            body: JSON.stringify(formData),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                props.onSuccess(data);
                props.dismiss();
            })
            .catch(err => { console.log(err) })
    }
    useEffect(() => {
        setName(props.data?.name);
        setSurname(props.data?.surname);
        setPersonalId(props.data?.personal_id);
        setPhone(props.data?.phone);
        setPostalCode(props.data?.postal_code);
        setCity(props.data?.city);
        setStreet(props.data?.street);
    }, [props.data])


    return (<StyledModal isOpen={props.data !== false} title={title} description={description} send={_send} dismiss={props.dismiss} actionLabel={'Edytuj'}>
        <Stack direction={'row'} spacing={2}>
            <Stack spacing={2} sx={{flexGrow: '1'}}>
                <TextField
                    onChange={(e) => setName(e.target.value)}
                    label='Imię'
                    value={name}
                    variant="outlined"
                    fullWidth
                />
        <TextField
            onChange={(e) => setSurname(e.target.value)}
            label='Nazwisko'
            value={surname}
            variant="outlined"
            fullWidth
        />
        <TextField
            onChange={(e) => setPersonalId(e.target.value)}
            label='Pesel'
            value={personalId}
            variant="outlined"
            required
            slotProps={{htmlInput: {minLength: 11, maxLength: 11}}}
            fullWidth
        />

            </Stack>
            <Stack spacing={2}>

                <TextField
                    onChange={(e) => setStreet(e.target.value)}
                    label='Adres'
                    value={street}
                    variant="outlined"
                    fullWidth
                />
                <Stack direction={'row'} spacing={2}>
                    <TextField
                        onChange={(e) => setPostalCode(e.target.value)}
                        label='Kod Pocztowy'
                        value={postalCode}
                        variant="outlined"

                    />
                    <TextField
                        onChange={(e) => setCity(e.target.value)}
                        label='Miasto'
                        value={city}
                        variant="outlined"
                        fullWidth
                    />
                </Stack>
                <TextField
                    onChange={(e) => setPhone(e.target.value)}
                    label='Telefon kontaktowy'
                    value={phone}
                    variant="outlined"
                    fullWidth
                />
            </Stack>
        </Stack>
        </StyledModal>);
}
export default EditChildren;